/* Extra angles on the PDP. Shopify images first; manufacturer overlay next.
   Does not write Spark/Shopify product records. */
(function () {
  var box = document.getElementById('gpc-product-gallery');
  if (!box) return;

  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function fileKey(url) {
    var path = String(url || '').split('?')[0];
    var file = path.split('/').pop() || '';
    return file.toLowerCase().replace(/_\d+(?=\.[a-z]+$)/, '');
  }

  function proxyUrl(url) {
    var base = (window.GPC && window.GPC.overlayImgUrl) || '';
    if (!base || !url) return url;
    if (/cdn\.shopify\.com/i.test(url)) return url;
    return base + '?u=' + encodeURIComponent(url);
  }

  var main = box.querySelector('.gpc-gallery-main');
  var thumbs = box.querySelector('.gpc-gallery-thumbs');
  var prev = box.querySelector('.gpc-gallery-prev');
  var next = box.querySelector('.gpc-gallery-next');
  if (!main || !thumbs) return;

  var dots = document.createElement('div');
  dots.className = 'gpc-gallery-dots';
  dots.setAttribute('aria-hidden', 'true');
  dots.hidden = true;
  box.insertBefore(dots, thumbs);

  function imgs() {
    return Array.prototype.slice.call(main.querySelectorAll('img'));
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function currentIndex() {
    var w = main.clientWidth;
    if (!w) return 0;
    return Math.max(0, Math.min(imgs().length - 1, Math.round(main.scrollLeft / w)));
  }

  function mark(i) {
    Array.prototype.forEach.call(thumbs.querySelectorAll('.gpc-gallery-thumb'), function (btn, idx) {
      if (idx === i) btn.classList.add('is-on');
      else btn.classList.remove('is-on');
    });
    Array.prototype.forEach.call(dots.querySelectorAll('.gpc-gallery-dot'), function (btn, idx) {
      if (idx === i) btn.classList.add('is-on');
      else btn.classList.remove('is-on');
    });
  }

  function show(i) {
    var list = imgs();
    if (!list.length) return;
    if (i < 0) i = list.length - 1;
    if (i >= list.length) i = 0;
    var w = main.clientWidth;
    main.scrollTo({ left: i * w, behavior: reduceMotion() ? 'auto' : 'smooth' });
    mark(i);
  }

  function rebuildDots() {
    var n = imgs().length;
    dots.innerHTML = '';
    dots.hidden = n < 2;
    if (prev) prev.hidden = n < 2;
    if (next) next.hidden = n < 2;
    for (var i = 0; i < n; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gpc-gallery-dot' + (i === currentIndex() ? ' is-on' : '');
      b.setAttribute('data-gpc-i', String(i));
      b.setAttribute('aria-label', 'Photo ' + (i + 1));
      dots.appendChild(b);
    }
  }

  function addThumb(src, index) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gpc-gallery-thumb' + (index === 0 ? ' is-on' : '');
    btn.setAttribute('data-gpc-i', String(index));
    btn.setAttribute('aria-label', 'Photo ' + (index + 1));
    var altEl = document.querySelector('[data-gpc-raw-title]');
    var alt = (altEl && altEl.getAttribute('data-gpc-raw-title')) || 'Product photo ' + (index + 1);
    btn.innerHTML = '<img src="' + esc(src) + '" alt="' + esc(alt) + '" width="160" height="160" loading="lazy" decoding="async">';
    thumbs.appendChild(btn);
  }

  function addImage(url, alt) {
    var src = proxyUrl(url);
    var seen = {};
    imgs().forEach(function (el) {
      seen[fileKey(el.getAttribute('data-gpc-src') || el.src)] = 1;
    });
    if (seen[fileKey(url)] || seen[fileKey(src)]) return false;
    var img = document.createElement('img');
    img.src = src;
    img.alt = alt || '';
    img.className = 'w-full';
    img.width = 1000;
    img.height = 1000;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.setAttribute('data-gpc-src', url);
    main.appendChild(img);
    addThumb(src, imgs().length - 1);
    rebuildDots();
    return true;
  }

  thumbs.addEventListener('click', function (e) {
    var btn = e.target.closest('.gpc-gallery-thumb');
    if (!btn || !thumbs.contains(btn)) return;
    show(parseInt(btn.getAttribute('data-gpc-i'), 10) || 0);
  });

  dots.addEventListener('click', function (e) {
    var btn = e.target.closest('.gpc-gallery-dot');
    if (!btn || !dots.contains(btn)) return;
    show(parseInt(btn.getAttribute('data-gpc-i'), 10) || 0);
  });

  if (prev) {
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      show(currentIndex() - 1);
    });
  }
  if (next) {
    next.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      show(currentIndex() + 1);
    });
  }

  var scrollTick = false;
  main.addEventListener('scroll', function () {
    if (scrollTick) return;
    scrollTick = true;
    window.requestAnimationFrame(function () {
      scrollTick = false;
      mark(currentIndex());
    });
  }, { passive: true });

  window.addEventListener('resize', function () {
    var i = currentIndex();
    var w = main.clientWidth;
    if (w) main.scrollLeft = i * w;
  });

  box.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    e.preventDefault();
    var i = currentIndex();
    if (e.key === 'ArrowLeft') show(i - 1);
    else show(i + 1);
  });

  rebuildDots();
  mark(0);

  function mergeSpecs(specs) {
    if (!specs) return;
    var ul = document.querySelector('#gpc-product-desc .gpc-desc-specs');
    if (!ul) return;
    var have = {};
    Array.prototype.forEach.call(ul.querySelectorAll('.gpc-desc-k'), function (el) {
      have[(el.textContent || '').trim().toUpperCase()] = 1;
    });
    Object.keys(specs).forEach(function (label) {
      var key = String(label || '').toUpperCase();
      if (!key || have[key]) return;
      var li = document.createElement('li');
      li.innerHTML = '<span class="gpc-desc-k">' + esc(label) + '</span> ' + esc(specs[label]);
      ul.appendChild(li);
      have[key] = 1;
    });
  }

  function loadOverlay() {
    var base = (window.GPC && window.GPC.overlayUrl) || '';
    if (!base) return;
    var upc = (box.getAttribute('data-upc') || '').replace(/\D/g, '');
    var sku = box.getAttribute('data-sku') || '';
    if (!upc && !sku) return;
    var url = base + '?upc=' + encodeURIComponent(upc) + '&sku=' + encodeURIComponent(sku) + '&v=2';
    fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var added = 0;
        (data.images || []).forEach(function (img) {
          if (img && img.url && addImage(img.url, img.alt || '')) added += 1;
        });
        if (imgs().length > 1) {
          thumbs.removeAttribute('hidden');
          rebuildDots();
        }
        mergeSpecs(data.specs || {});
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadOverlay);
  } else {
    loadOverlay();
  }
})();
